export default "__VITE_ASSET__C6R4$h3i__"